import styled from "styled-components"


export const ContainerInput = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: ${props => props.theme.gaps.medium};
    width: 100%;
    height: 42px;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
    border: ${props => props.theme.border.very_small_gray5};
    border-radius: ${props => props.theme.border_radius.small};

    img{
        width: 20px;
        margin-right: 8px;
    }

    .wrapper{
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding:${props => props.theme.paddings.medium} ;
    }

    input{
        width: 100%;
        color: ${props => props.theme.colors.gray};
    }

`
